import FormattedMessage from 'I18n/components/FormattedMessage';
import { INCOMPLETE_SETUP_GO_TO_OPTIONS } from 'FormsUI/constants/TrackingInteractionKeys/Editor/OptionsTab';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getPaymentOptionsLink } from 'FormsUI/lib/RouteGenerators';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const IncompleteSetupTooltipMessage = () => /*#__PURE__*/_jsx(FormattedReactMessage, {
  message: 'editor.options.payment.incompleteSetupTooltip.body',
  options: {
    goToPayments: /*#__PURE__*/_jsx(Link, {
      href: getPaymentOptionsLink(),
      external: true,
      onClick: () => trackEditorInteraction(INCOMPLETE_SETUP_GO_TO_OPTIONS),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'editor.options.payment.incompleteSetupTooltip.link'
      })
    })
  }
});
export default IncompleteSetupTooltipMessage;